import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './fonts.css';
import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init('jhKyry4tD9gZMUsM0');

createRoot(document.getElementById("root")!).render(<App />);
